import * as types from "./actionTypes";

export const postDrivingForm = (formName, formContent) => ({
  type: types.POST_DRIVING_FORM,
  payload: { formName, formContent },
});

export const submitDrivingOnboarding = (drivingContent) => ({
  type: types.SUBMIT_DRIVING_ONBOARDING,
  payload: { drivingContent },
});

export const drivingOnboardingSubmitted = () => ({
  type: types.DRIVING_ONBOARDING_SUBMITTED,
});
